var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"education-content tabs-full",attrs:{"type":"card"},on:{"tab-click":_vm.toggleOperationTab},model:{value:(_vm.decorationTab),callback:function ($$v) {_vm.decorationTab=$$v},expression:"decorationTab"}},[_c('el-tab-pane',{attrs:{"label":"装修管理","name":"decorationData"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }